export default "__VITE_PUBLIC_ASSET__2d49ce2f__"